import * as React from 'react';

import {FeatureGateModalWrapper} from '../limits/feature-gates/feature-gate-modal-wrapper';

type Props = {
    isOpen: boolean;
    onClose: () => void;
};

export function ManagedMeetingsFeatureGateModal(props: Props) {
    const {isOpen, onClose} = props;

    return (
        <FeatureGateModalWrapper
            title='Upgrade your plan to Business or Enterprise to start now'
            description='Create managed meetings for your team so they can focus on bookings instead'
            bullets={[
                'Configure meetings so that new users automatically have Scheduler meetings ready-to-go',
                'Ensure all meetings maintain consistency that align with your company’s standards',
            ]}
            feature='schedulerFull'
            isOpen={isOpen}
            onClose={onClose}
        />
    );
}
